/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ db: NonNullable<unknown> }} Audio_Description_Export_Automix_Threshold_LabelInputs */



/**
* | output |
* | --- |
* | "Threshold ({db} dB)" |
*
* @param {Audio_Description_Export_Automix_Threshold_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_automix_threshold_label = /** @type {((inputs: Audio_Description_Export_Automix_Threshold_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Automix_Threshold_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Seuil (${i?.db} dB)`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Schwellenwert (${i?.db} dB)`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Soglia (${i?.db} dB)`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Пороговое значение (${i?.db} дБ)`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Umbral (${i?.db} dB)`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`阈值（${i?.db} dB）`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`閾値（${i?.db} dB）`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`सीमा (${i?.db} dB)`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Limiar (${i?.db} dB)`)
	return /** @type {LocalizedString} */ (`Threshold (${i?.db} dB)`)
});